module.exports = __webpack_public_path__ + "assets/img/SpinTel-Social-Static-Ad-w960.7da99e0a.png";